function valida(params, obj){

  
  
  
  
  
  return false;
}


export default {
  messages: {
    en: (field, args) => {
      return "Por favor selecione um item da lista";
    },
    'pt-BR': (field, args) => {
      return "Por favor selecione um item da lista";
    }
  },
  validate(params, obj) {
    return valida(params, obj);
  }
};



// WEBPACK FOOTER //
// ./src/validators/google-autocomplete.js